module.exports = __webpack_public_path__ + "static/TangleTower7-15a3c424361450ae3e4c404ebb576ce1.png";